import TBCH from "../static/tbch logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { PulseLoader } from "react-spinners";

export default function Login() {
  const forward = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [load, setLoad] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    success: true,
  });

  useEffect(() => {
    document.title = "Login | TBCH";
  }, []);

  useEffect(() => {
    if (localStorage.getItem("current-user")) {
      forward("/");
    }
  }, [forward]);

  // user
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoad(true);
    if (!email.length || !password.length) {
      setMessage({
        ...message,
        message: "Important fields missing",
        success: false,
      });
      setLoad(false);
      setTimeout(() => {
        setMessage({ ...message, message: "", success: false });
      }, 2000);
      return;
    }

    const data = {
      email: email.trim(),
      password: password.trim(),
    };

    axios
      .post("/_tbch-api/login", data)
      .then((d) => {
        if (d.data.success) {
          localStorage.setItem("current-user", d.data.jwt);
          setMessage({
            ...message,
            message: d.data.message,
            success: d.data.success,
          });
          setLoad(false);
          setTimeout(() => {
            setMessage({ ...message, message: "", success: true });
            forward("/");
          }, 2000);
        } else {
          setMessage({
            ...message,
            message: d.data.message,
            success: d.data.success,
          });
          setLoad(false);
          setTimeout(() => {
            setMessage({ ...message, message: "", success: false });
          }, 5000);
        }
      })
      .catch((e) => {
        setMessage({
          ...message,
          message: "Can't connect to server.",
          success: false,
        });
        setLoad(false);
        setTimeout(() => {
          setMessage({ ...message, message: "", success: false });
        }, 5000);
      });
  };

  const sideBar = () => {
    if (sidebar) {
      return setSidebar(false);
    } else {
      return setSidebar(true);
    }
  };

  return (
    <div className="main">
      <nav
        className="mobile-nav"
        style={
          sidebar
            ? { transform: "translateX(0%)" }
            : { transform: "translateX(100%)" }
        }
      >
        <div className="close-button-wrap">
          <i class="lni lni-cross-circle" onClick={sideBar}></i>
        </div>
        <div className="choices">
          <span>
            <Link to="/">Return</Link>
          </span>
        </div>
        <img src={TBCH} alt="" />
        <div className="mark">
          <span>@ctxsoftwaresphilippines</span>
          <span>@charliecatxph</span>
          <span>
            Designed and developed by : Charl Concepcion, CEO of CTX Softwares
            Philippines
          </span>
        </div>
      </nav>
      <section className="landing-page bg-src">
        <div className="darken"></div>
        <nav className="nav-bar">
          <div className="container">
            <div className="logo">
              <img src={TBCH} alt="" />
            </div>
            <div className="navbar-buttons">
              <div className="button">
                <span>
                  <Link to="/">Return</Link>
                </span>
              </div>
            </div>
            <div className="burger-menu-btn" onClick={sideBar}>
              <i class="lni lni-menu"></i>
            </div>
          </div>
        </nav>
        <div className="container">
          <div className="wrap-form">
            <form onSubmit={handleLogin}>
              <div
                className="message-response"
                style={
                  message.success
                    ? { backgroundColor: "#2ecc71" }
                    : { backgroundColor: "#e74c3c" }
                }
              >
                <span>{message.message}</span>
              </div>
              <h1>Login:</h1>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                id=""
                onChange={handleEmailChange}
                required
                placeholder="myemail@mydomain.com"
              />
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id=""
                onChange={handlePasswordChange}
                required
                placeholder="password"
              />
              <span>
                <i>
                  <Link to="/forgot-password">forgot your password?</Link>
                </i>
              </span>
              <span>
                <Link to="/register">New to TBCH? Register now!</Link>
              </span>
              <button type="submit" className="submit-btn">
                {load ? (
                  <PulseLoader color={"#FFFFFF"} loading={load} size={5} />
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
